import React from 'react';

const RevenueCenterTitle = ({ record }) => {
	return <span>RevenueCenter {record ? `"${record.name}"` : ''}</span>;
};

export default RevenueCenterTitle;
